import React, { useState } from "react";
import { Tabs } from "../../_styleguide";
import { IconReport } from "@tabler/icons-react";
import { useNavigate, useParams, Link } from "react-router-dom";
import { Header, Text } from "@centrate-io/barn";
import "./PricingModule.scss";
import AddToSaleTable from "./_components/AddToSaleTable/AddToSaleTable";

function AddToSale(props) {
    const navigate = useNavigate();
    const params = useParams();
    const [tab, setTab] = useState(params?.tab) || "sample-tab";
    const deal_id = params.id;
  
    let items = [
      {
        key: "add-to-sale-table",
        label: (
          <div className="tab-name">
            <IconReport />
            Add To Sale Table
          </div>
        ),
        children: <AddToSaleTable/>,
      },
      {
        key: "sample-tab",
        label: (
          <div className="tab-name">
            <IconReport />
            Sample Tab
          </div>
        ),
        children: <></>,
      },
      {
        key: "sample-tab-2",
        label: (
          <div className="tab-name">
            <IconReport />
            Sample Tab 2
          </div>
        ),
        children: <></>,
      }
    ];
  
    return (
      <div className="admin-tabs app-sale">
        <div className="admin-header">
          <div className="crumbs" >
            <Header type="display" size="5">
              Add To Sale
            </Header>
          </div>
        </div>
        <Tabs
          onChange={(key) => {
            navigate(`/deal/${deal_id}/add-to-sale/${key}`);
            setTab(key);
          }}
          activeKey={tab}
          items={items}
          className={tab}
          destroyInactiveTabPane={true}
        />
      </div>
    );
  }
  
  export default AddToSale;